import { render, staticRenderFns } from "./EditDtc.vue?vue&type=template&id=154e3a64&scoped=true&"
import script from "./EditDtc.vue?vue&type=script&lang=js&"
export * from "./EditDtc.vue?vue&type=script&lang=js&"
import style0 from "./EditDtc.vue?vue&type=style&index=0&id=154e3a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e3a64",
  null
  
)

export default component.exports